"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uploadBase = _interopRequireDefault(require("../upload-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Represents a response received from the HttpClient after submitting a request. Provides
 * various accessors for retrieving information from the response.
 */
var HttpResponse = /*#__PURE__*/function (_UploadBase) {
  _inherits(HttpResponse, _UploadBase);

  var _super = _createSuper(HttpResponse);

  /**
   * Constructs a new response, which will use raw response values from the underlying
   * module that performs HTTP communication.
   *
   * @param {object} options Direct binary options.
   * @param {object} rawResponse Raw response data.
   */
  function HttpResponse(options, rawResponse) {
    var _this;

    _classCallCheck(this, HttpResponse);

    _this = _super.call(this, options);
    _this.rawResponse = rawResponse;
    return _this;
  }
  /**
   * Retrieves the HTTP status code of the response.
   *
   * @returns {number} HTTP status code.
   */


  _createClass(HttpResponse, [{
    key: "getStatusCode",
    value: function getStatusCode() {
      return this.rawResponse ? this.rawResponse.status : 0;
    }
    /**
     * Retrieves the response status text.
     *
     * @returns {string} HTTP response status.
     */

  }, {
    key: "getStatusText",
    value: function getStatusText() {
      return this.rawResponse ? this.rawResponse.statusText : '';
    }
    /**
     * Retrieves the response's header values.
     *
     * @returns {object} Simple object whose keys are header names
     *  and whose values are header values.
     */

  }, {
    key: "getHeaders",
    value: function getHeaders() {
      return this.rawResponse ? this.rawResponse.headers || {} : {};
    }
    /**
     * Retrieves any data provided in the response body. Note that the
     * type of this value will vary depending on the response type set
     * on the request.
     *
     * @returns {*} Varies, depending on the request.
     */

  }, {
    key: "getData",
    value: function getData() {
      return this.rawResponse ? this.rawResponse.data : '';
    }
    /**
     * Retrieves the amount of time it took between the request being
     * sent and the server providing a response.
     *
     * @returns {number} Time span, in milliseconds.
     */

  }, {
    key: "getElapsedTime",
    value: function getElapsedTime() {
      return this.rawResponse ? this.rawResponse.elapsedTime : 0;
    }
  }]);

  return HttpResponse;
}(_uploadBase.default);

exports.default = HttpResponse;